import Vue from 'vue';
import Vuex from 'vuex';
import { getToken, setToken, removeToken ,getLoginMethod,setLoginMethod,removeLoginMethod} from '@/utils/auth';
import {
  login,
  register,
  synchronousData,
  loginByRegisNumber, loginByIdCard, resetPwd,
} from '@/api/user';
import { getRegistrationNumber } from '@/api/registrate';
import { getMenu, queryExamPhase } from '@/api/menu';
import Cookies from 'js-cookie'; // 假设使用 js-cookie 库来处理 cookie

Vue.use(Vuex);

// 获取当前页面的 URL
// const url = new URL(window.location.href);
// console.log(url, 'url===================');
// console.log(url.search, 'url.search===================');
// // 使用 URLSearchParams 解析查询参数
// const params = new URLSearchParams(url.search);
// console.log(params, 'params---------------');

// // 获取 token 参数
// const token = params.get('token');
// console.log(token, 'token===================');
// const userName = params.get('userName');
// console.log(userName, 'userName===================');
// const userId = params.get('userId');
// console.log(userId, 'userId===================');
// const phone = params.get('phone');
// console.log(phone, 'phone===================');

// // 创建 userInfo 对象
// const userInfo = {
//   token: token || null,
//   userName: userName || null,
//   userId: userId || null,
//   phone: phone || null,
// };

// // 如果 token 存在，则调用 setToken 方法进行存储
// if (token) {
//   if (getToken()) {
//     removeToken();
//   }
//   setToken(token);
//   if (localStorage.getItem('token')) {
//     localStorage.removeItem('token');
//   }
//   localStorage.setItem('token', token);

//   // 将 userInfo 对象存储到 localStorage
//   if (localStorage.getItem('userInfo')) {
//     localStorage.removeItem('userInfo');
//   }
//   localStorage.setItem('userInfo', JSON.stringify(userInfo));
//   console.log('userInfo-------', localStorage.getItem('userInfo'));
//   // 直接调用方式
//   // this.$store.commit('SET_USERINFO', JSON.stringify(userInfo));
//   // this.$store.dispatch('Login', {
//   //   username: '510203198310010818',
//   //   password: 'hq@68903995',
//   // });
// }

// const parseQueryParams = (url) => {
//   const queryParams = {};
//   const queryString = url.split('?')[1];
//   const pairs = queryString.split('&');
//   pairs.forEach((pair) => {
//     const [key, value] = pair.split('=');
//     queryParams[key] = decodeURIComponent(value || '');
//   });
//   return queryParams;
// };

export default new Vuex.Store({
  state: {
    user: null,
    //token: localStorage.getItem('token') || null,
    token: getToken(),
    currentMenuIndex: 0,
    currentMenuPath: null,
    userInfo: localStorage.getItem('userInfo') || null,
    isUpdateMenu: false,
    updateMenuPath: null,
    nextMenuPath: null,
    flag: '',
    showValidate:false
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    },
    SET_CURRENT_MENU_INDEX(state, index) {
      state.currentMenuIndex = index;
    },
    SET_CURRENT_MENU_PATH(state, path) {
      state.currentMenuPath = path;
    },
    SET_USERINFO(state, data) {
      state.userInfo = data;
    },
    SET_IS_UPDATE_MENU(state, val) {
      state.isUpdateMenu = val;
    },
    SET_UPDATE_MENU_PATH(state, path) {
      state.updateMenuPath = path;
    },
    SET_NEXT_MENU_PATH(state, path) {
      state.nextMenuPath = path;
    },
    SET_FLAG(state, val) {
      state.flag = val;
    },
    CHANGE_VALIDATE(state, val){
      state.showValidate = val;
    }
  },
  actions: {
    // 登录
    async Login({ commit }, userInfo) {
      console.log(userInfo, 'userInfo');
      const { username, password } = userInfo;
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((data) => {
            console.log(data, 'data');
            if (data.code == 200) {
              commit('SET_USER', data.data.userId);
              commit('SET_TOKEN', data.data.token);
              commit('SET_USERINFO', JSON.stringify(data.data));
              // Cookies.set('JavaInfo', JSON.stringify(data));
              setToken(data.data.token);
              setLoginMethod(1)
              resolve(data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
      // try {
      //   // TODO: 替换为实际的 API 调用
      //   const response = await fetch(
      //     `${process.env.VUE_APP_BASE_API}/user/login`,
      //     {
      //       method: 'POST',
      //       headers: {
      //         'Content-Type': 'application/json',
      //         isToken: false,
      //       },
      //       body: JSON.stringify(credentials),
      //     }
      //   );

      //   if (!response.ok) {
      //     throw new Error('登录失败');
      //   }

      //   const data = await response.json();
      //   commit('SET_USER', data.user);
      //   commit('SET_TOKEN', data.token);
      //   return true;
      // } catch (error) {
      //   console.error('登录错误:', error);
      //   return false;
      // }
    },
    //自己系统得登录
    async LoginBySelfAcount({ commit }, userInfo) {
      console.log(userInfo, 'userInfo');
      const { username, password } = userInfo;
      return new Promise((resolve, reject) => {
        loginByIdCard(userInfo)
            .then((data) => {
              console.log(data, 'data');
              if (data.code == 200) {
                commit('SET_USER', data.data.userId);
                commit('SET_TOKEN', data.data.token);
                commit('SET_USERINFO', JSON.stringify(data.data));
                // Cookies.set('JavaInfo', JSON.stringify(data));
                setToken(data.data.token);
                setLoginMethod(3)
                resolve(data);
              }
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
    // 登录2
    async LoginByRegisNumber({ commit }, userInfo) {
      console.log(userInfo, 'userInfo');
      return new Promise((resolve, reject) => {
        loginByRegisNumber(userInfo)
          .then((data) => {
            console.log(data, 'data');
            if (data.code == 200) {
              commit('SET_USER', data.data.userId);
              commit('SET_TOKEN', data.data.token);
              commit('SET_USERINFO', JSON.stringify(data.data));
              // Cookies.set('JavaInfo', JSON.stringify(data));
              setToken(data.data.token);
              setLoginMethod(2)
              resolve(data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 注册
    async Register({ commit }, userData) {
      console.log(userData, 'userData');
      const { username, password } = userData;
      return new Promise((resolve, reject) => {
        register(userData)
          .then((data) => {
            console.log(data, 'data');
            // commit('SET_USER', data.user);
            // commit('SET_TOKEN', data.token);
            // Cookies.set('JavaInfo', JSON.stringify(data));
            // setToken(data.token);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 登出
    logout({ commit }) {
      commit('SET_USER', null);
      commit('SET_TOKEN', null);
      commit('SET_USERINFO', {});
      removeToken();
      if (localStorage.getItem('regisNumberChoose')) {
        localStorage.removeItem('regisNumberChoose');
      }
      if (localStorage.getItem('registrationNumber')) {
        localStorage.removeItem('registrationNumber');
      }
      if (localStorage.getItem('userInfo')) {
        localStorage.removeItem('userInfo');
      }
      if (localStorage.getItem('examId')) {
        localStorage.removeItem('examId');
      }
      if (localStorage.getItem('phaseType')) {
        localStorage.removeItem('phaseType');
      }
      if (localStorage.getItem('pathName')) {
        localStorage.removeItem('pathName');
      }
      if (localStorage.getItem('path')) {
        localStorage.removeItem('path');
      }
      if (localStorage.getItem('examName')) {
        localStorage.removeItem('examName');
      }
      if (localStorage.getItem('startTime')) {
        localStorage.removeItem('startTime');
      }
      if (localStorage.getItem('endTime')) {
        localStorage.removeItem('endTime');
      }
      // if (localStorage.getItem('loginType')) {
      //   localStorage.removeItem('loginType');
      // }不能移除，否则登录方式有问题
      if (localStorage.getItem('userInfoDetail')) {
        localStorage.removeItem('userInfoDetail');
      }
    },

    // 重置密码
    async resetPassword({ commit }, resetData) {
      console.log(resetData, 'userData');
      const { username, password } = resetData;
      return new Promise((resolve, reject) => {
        resetPwd(resetData)
            .then((data) => {
              console.log(data, 'data');
              // commit('SET_USER', data.user);
              // commit('SET_TOKEN', data.token);
              // Cookies.set('JavaInfo', JSON.stringify(data));
              // setToken(data.token);
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
      });
    },

    // 添加手机验证码登录方法
    async phoneLogin({ commit }, { phone, code }) {
      try {
        // TODO: 替换为实际的 API 调用
        const response = await fetch('/api/phone-login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ phone, code }),
        });

        if (!response.ok) {
          throw new Error('登录失败');
        }

        const data = await response.json();
        commit('SET_USER', data.user);
        commit('SET_TOKEN', data.token);
        return true;
      } catch (error) {
        console.error('手机登录错误:', error);
        return false;
      }
    },

    // 添加发送验证码方法
    async sendVerificationCode(_, { phone }) {
      try {
        // TODO: 替换为实际的 API 调用
        const response = await fetch('/api/send-code', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ phone }),
        });

        if (!response.ok) {
          throw new Error('发送验证码失败');
        }

        return true;
      } catch (error) {
        console.error('发送验证码错误:', error);
        return false;
      }
    },

    // 获取用户信息
    async getUserInfo({ commit }) {
      try {
        // TODO: 替换为实际的 API 调用
        return {
          success: true,
          data: {
            examTitle:
              '2024年重庆市中医医师规范化培训和中医助理全科医生培训结业考核',
            userName: '张三',
            idNumber: '500000000000000',
            steps: [
              { name: '考生报名', status: 'active' },
              { name: '资格审核', status: 'pending' },
              { name: '考生缴费', status: 'pending' },
              { name: '打印准考证', status: 'pending' },
              { name: '成绩查询', status: 'pending' },
            ],
          },
        };
      } catch (error) {
        console.error('获取用户信息失败:', error);
        return { success: false };
      }
    },

    // 获取菜单列表
    async getMenuList({ commit }) {
      try {
        if (
          localStorage.getItem('examId') &&
          localStorage.getItem('phaseType')
        ) {
          const examId = JSON.parse(localStorage.getItem('examId'));
          const phaseType = JSON.parse(localStorage.getItem('phaseType'));

          const phaseResponse = await queryExamPhase({ examId });
          // console.log(phaseResponse, 'menu=====');

          if (phaseResponse.code == 200 && phaseResponse.data) {
            const arr1 = Array.isArray(phaseResponse.data['进行中'])
              ? phaseResponse.data['进行中']
              : [];
            const arr2 = Array.isArray(phaseResponse.data['未开始'])
              ? phaseResponse.data['未开始']
              : [];
            const arr3 = Array.isArray(phaseResponse.data['已结束'])
              ? phaseResponse.data['已结束']
              : [];
            let examList = [...arr1, ...arr2, ...arr3];
            const targetItem = examList.find(
              (item) => item.phaseType == phaseType
            );
            // console.log(targetItem, 'targetItem=====');

            if (targetItem) {
              const examArrangeId = targetItem.id;
              let obj = {
                examId,
                examArrangeId,
                flag: this.state.flag,
              };
              const menuResponse = await getMenu(obj);
              // console.log(menuResponse, 'menu=====');

              if (menuResponse.code == 200 && menuResponse.data) {
                const menuList = menuResponse.data.map((item) => ({
                  path: item.menuPath,
                  name: item.menuName,
                  sort: item.sort,
                }));
                // 按照 sort 升序排序
                menuList.sort((a, b) => a.sort - b.sort);
                // console.log(menuList, 'menuList2222=====');

                // 去重处理 - 根据path去重
                const uniqueMenuList = [
                  ...new Map(
                    menuList.map((item) => [item.path, item])
                  ).values(),
                ];
                // 按照 sort 升序排序
                uniqueMenuList.sort((a, b) => a.sort - b.sort);

                return {
                  success: true,
                  data: uniqueMenuList,
                };
              }
            }
          }
        } else {
          const examId = JSON.parse(localStorage.getItem('examId'));
          let obj = {
            examId,
            flag: this.state.flag,
          };
          const menuResponse = await getMenu(obj);
          console.log(menuResponse, 'menu=====');

          if (menuResponse.code == 200 && menuResponse.data) {
            const menuList = menuResponse.data.map((item) => ({
              path: item.menuPath,
              name: item.menuName,
              sort: item.sort,
            }));
            // 按照 sort 升序排序
            menuList.sort((a, b) => a.sort - b.sort);
            // console.log(menuList, 'menuList1111=====');

            // 去重处理 - 根据path去重
            const uniqueMenuList = [
              ...new Map(menuList.map((item) => [item.path, item])).values(),
            ];
            // 按照 sort 升序排序
            uniqueMenuList.sort((a, b) => a.sort - b.sort);

            return {
              success: true,
              data: uniqueMenuList,
            };
          }
        }
      } catch (error) {
        console.error('Error fetching menu:', error);
        return {
          success: false,
          menuList: [],
        };
      }
      // try {
      //   // return {
      //   //   success: true,
      //   //   data: [
      //   //     { name: '考试文件', path: '/candidate-registrate/exam-documents' },
      //   //     { name: '报名填表', path: '/candidate-registrate/basic-info' },
      //   //     { name: '照片维护', path: '/photo-upload' },
      //   //     { name: '证件资料', path: '/document-upload' },
      //   //     { name: '信息维护', path: '/info-maintain' },
      //   //     { name: '报名确认', path: '/info-confirm' },
      //   //     { name: '打印报名表', path: '/print-ticket' },
      //   //     //////// //////// //////// //////// //////// //////// ////////
      //   //     { name: '网上缴费', path: '/examineePayment/onlinePay' },
      //   //     { name: '打印准考证', path: '/printAdmissionTicket/printTicket' },
      //   //     { name: '成绩查询', path: '/queryGradesModel/printGrades' }, //name:打印成绩单
      //   //     { name: '详细信息', path: '/qualificationReview/reviewInfoDetail' },
      //   //   ],
      //   // };
      //   //考生报名0  资格审核1 考生缴费2  打印准考证3 考试时间4 成绩查询5
      //   if (
      //     localStorage.getItem('examId') &&
      //     localStorage.getItem('phaseType')
      //   ) {
      //     let menuList = [];
      //     let examArrangeIds;
      //     queryExamPhase({
      //       examId: JSON.parse(localStorage.getItem('examId')),
      //     }).then((res) => {
      //       console.log(res, 'menu=====');
      //       if (res.code == 200 && res.data) {
      //         let targetItem = res.data.filter(
      //           (item) =>
      //             item.phaseType ==
      //             JSON.parse(localStorage.getItem('phaseType'))
      //         );
      //         examArrangeIds = targetItem[0].id;

      //         getMenu({
      //           examId: JSON.parse(localStorage.getItem('examId')),
      //           examArrangeId: examArrangeIds,
      //         }).then((res) => {
      //           console.log(res, 'menu=====');
      //           if (res.code == 200 && res.data) {
      //             menuList = res.data.map((item) => {
      //               return {
      //                 path: item.menuPath,
      //                 name: item.menuName,
      //               };
      //             });
      //             return {
      //               success: true,
      //               menuList,
      //             };
      //           }
      //         });
      //       }
      //     });
      //   }
      // } catch (error) {
      //   console.error('获取菜单列表失败:', error);
      //   return { success: false };
      // }
    },

    // 获取下一个菜单项的路由
    // async getNextMenuPath({ state, dispatch, commit }) {
    //   try {
    //     const response = await dispatch('getMenuList');
    //     if (response.success) {
    //       const menuList = response.data;
    //       // 获取当前路径
    //       let currentPath = state.currentMenuPath;

    //       // 如果是 register-notice 页面，使用其父页面路径
    //       // if (currentPath.includes('/register-notice')) {
    //       //   currentPath = '/candidate-registrate/basic-info';
    //       // }

    //       // 找到当前菜单项的索引
    //       const currentIndex = menuList.findIndex(
    //         (item) => item.path === currentPath
    //       );

    //       if (currentIndex !== -1 && currentIndex < menuList.length - 1) {
    //         const nextPath = menuList[currentIndex + 1].path;
    //         // 更新当前菜单路径
    //         commit('SET_CURRENT_MENU_PATH', nextPath);
    //         return nextPath;
    //       }
    //     }
    //     return null;
    //   } catch (error) {
    //     console.error('获取下一个菜单路由失败:', error);
    //     return null;
    //   }
    // },

    // 初始化当前菜单路径
    // async initCurrentMenuPath({ dispatch, commit }) {
    //   try {
    //     const response = await dispatch('getMenuList');
    //     console.log('获取菜单列表成功:', response);
    //     if (response.success && Array.isArray(response.data) && response.data.length > 0 && response.data[0].hasOwnProperty('path')) {
    //       commit('SET_CURRENT_MENU_PATH', response.data[0].path);
    //     } else {
    //       console.error('菜单数据无效或不完整:', response.data);
    //     }
    //   } catch (error) {
    //     console.error('初始化菜单路径失败:', error);
    //   }
    // },

    //获取报名序号
    getRegistration() {
      if (localStorage.getItem('examId')) {
        getRegistrationNumber({
          // examId: '1882698284408582145',
          examId: JSON.parse(localStorage.getItem('examId')),
        }).then((res) => {
          console.log(res, 'resregistrationNumber=====');
          if (res.code == 200 && res.data) {
            this.registrationNumber = res.data;
            if (localStorage.getItem('registrationNumber')) {
              localStorage.removeItem('registrationNumber');
            }
            localStorage.setItem(
              'registrationNumber',
              JSON.stringify(this.registrationNumber)
            );
          }
        });
      }
    },

    //同步数据  获取第三方数据
    async getUserInfoVar({ commit }, userInfo) {
      console.log(userInfo, 'userInfo8888888------===========');
      return new Promise((resolve, reject) => {
        synchronousData(userInfo)
          .then((data) => {
            console.log(data, 'data7777799999=============');
            if (data.code == 200) {
              commit('CHANGE_VALIDATE',false)
              localStorage.setItem('loginType', '1')
              setLoginMethod(1)
              console.log(555555555555,getLoginMethod(),'/////////////login',localStorage.getItem('loginType'));
              commit('SET_TOKEN', userInfo.token);
              commit('SET_USERINFO', JSON.stringify({...userInfo,username:data.data.username}));
              if (localStorage.getItem('userInfo')) {
                localStorage.removeItem('userInfo');
              }
              localStorage.setItem('userInfo', JSON.stringify({...userInfo,username:data.username}));
              // Cookies.set('JavaInfo', JSON.stringify(data));
              setToken(userInfo.token);
              resolve(data);
            }
          })
          .catch((error) => {
            console.log(error,'/////545454545')
            if(error.code==10010){
              commit('CHANGE_VALIDATE',true)
            }
            reject(error);
          });
      });
    },
  },
});
